/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React from 'react';
import { Text, TouchableOpacity } from 'react-native';
import { styles } from '../ReportsScreen.styles';
import { colors } from '../../../shared/theme/colors'
import { spacing } from '../../../shared/theme/spacing';
import { ReportsDenseListCard } from './ReportsDenseListCard';

type Props = {
  message: string;
  showRetry?: boolean;
  onRetry?: () => void;
  retryAccessibilityLabel?: string;
};

/** Error de carga inline (card borde rojo + Reintentar) — mismo patrón que Cierres de caja. */
export function ReportsErrorRetryCard({
  message,
  showRetry = true,
  onRetry,
  retryAccessibilityLabel = 'Reintentar cargar datos',
}: Props) {
  return (
    <ReportsDenseListCard wrapStyle={{ borderColor: colors.danger, marginTop: spacing.sm }}>
      <Text style={styles.errorText}>{message}</Text>
      {showRetry && onRetry ? (
        <TouchableOpacity
          style={styles.primaryButton}
          onPress={onRetry}
          accessibilityLabel={retryAccessibilityLabel}
          accessibilityRole="button"
        >
          <Text style={styles.primaryButtonText}>Reintentar</Text>
        </TouchableOpacity>
      ) : null}
    </ReportsDenseListCard>
  );
}
